__turbopack_context__.v({
  "blurSignature": "GenplanSignatures-module-scss-module__ts_CKq__blurSignature",
  "fgbu": "GenplanSignatures-module-scss-module__ts_CKq__fgbu",
  "fgup": "GenplanSignatures-module-scss-module__ts_CKq__fgup",
  "fmba": "GenplanSignatures-module-scss-module__ts_CKq__fmba",
  "hospital": "GenplanSignatures-module-scss-module__ts_CKq__hospital",
  "road": "GenplanSignatures-module-scss-module__ts_CKq__road",
  "school": "GenplanSignatures-module-scss-module__ts_CKq__school",
  "signature": "GenplanSignatures-module-scss-module__ts_CKq__signature",
  "stageOneOne": "GenplanSignatures-module-scss-module__ts_CKq__stageOneOne",
  "stageThree": "GenplanSignatures-module-scss-module__ts_CKq__stageThree",
  "stageTwoOne": "GenplanSignatures-module-scss-module__ts_CKq__stageTwoOne",
  "stageTwoThree": "GenplanSignatures-module-scss-module__ts_CKq__stageTwoThree",
  "stageTwoTwo": "GenplanSignatures-module-scss-module__ts_CKq__stageTwoTwo",
});
